import { Dictionary, PropsWithType } from './types';

export function arrayToObject<T>(arr: T[], keyField: PropsWithType<T, string>, initialObj: Dictionary<T> = {}): Dictionary<T> {
  return arr.reduce((obj, item) => {
    // `any` cast due to TS not being able to understand that PropsWithType<T, string> only returns strings
    const key: string = item[keyField] as any;
    obj[key] = item;
    return obj;
  }, initialObj);
}
